module.exports = __webpack_public_path__ + "img/isotipo.65ee9c0f.png";